import React from "react";
import "./CombineImageModal.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { combineImage, addPageImageApi, cropImageApi } from "../../api/pages";
import { base64ToBlob } from "../../utils/utils";

class CombineImageModal extends React.Component {
  constructor(props) {
    super(props);
    this.save = this.save.bind(this);
    this.switchClicked = this.switchClicked.bind(this);
    this.cropClicked = this.cropClicked.bind(this);
    this.handleCloseCreateModal = this.handleCloseCreateModal.bind(this);
    this.renderStep0 = this.renderStep0.bind(this);
    this.renderStep1 = this.renderStep1.bind(this);
    this.renderStep2 = this.renderStep2.bind(this);

    this.state = {
      isProcessing: false,
      step: 0,
      combinedImage: null,
      croppedCombinedImage: null
    };
  }

  async save() {
    if (this.state.step <= 0) {
      const { pageID, leftImageID, rightImageID } = this.props;

      this.setState({ isProcessing: true });

      try {
        const image = await combineImage(pageID, leftImageID, rightImageID);
        this.setState({
          isProcessing: false,
          step: 1,
          combinedImage: image.data
        });
      } catch (e) {
        toast.error(e.toString());
        this.setState({ isProcessing: false });
      }
    } else if (this.state.step > 0) {
      const { pageID } = this.props;
      const { combinedImage, croppedCombinedImage, step } = this.state;

      const imageToBeSaved = step === 1 ? combinedImage : croppedCombinedImage;

      this.setState({ isProcessing: true });

      try {
        await addPageImageApi(
          pageID,
          base64ToBlob(imageToBeSaved, "image/jpg"),
          null
        );
        this.setState({
          isProcessing: false,
          combinedImage: null,
          croppedCombinedImage: null,
          step: 0
        });

        this.props.handleCloseModal(true);
      } catch (e) {
        toast.error(e.toString());
        this.setState({ isProcessing: false });
      }
    }
  }

  async cropClicked() {
    const { pageID } = this.props;
    const { combinedImage } = this.state;

    this.setState({ isProcessing: true });

    try {
      const image = await cropImageApi(pageID, base64ToBlob(combinedImage));
      this.setState({
        isProcessing: false,
        step: 2,
        croppedCombinedImage: image.data
      });
    } catch (e) {
      toast.error(e.toString());
      this.setState({ isProcessing: false });
    }
  }

  handleCloseCreateModal() {
    if (this.state.step > 0) {
      this.setState({ step: this.state.step - 1 });
      return;
    }

    this.setState({
      isProcessing: false,
      combinedImage: null,
      croppedCombinedImage: null,
      step: 0
    });

    this.props.handleCloseModal(false);
  }

  switchClicked() {
    this.props.handleCombineSwitch();
  }

  renderStep0() {
    return (
      <React.Fragment>
        <Row>
          <Col
            xs="6"
            sm="6"
            md="6"
            lg="6"
            xl="6"
            style={{ textAlign: "right" }}
          >
            <Image
              className="selected_image"
              src={`${process.env.REACT_APP_API_ROOT}artworks/${
                this.props.leftImageID
              }/static`}
            />
          </Col>
          <Col xs="6" sm="6" md="6" lg="6" xl="6" style={{ textAlign: "left" }}>
            <Image
              className="selected_image"
              src={`${process.env.REACT_APP_API_ROOT}artworks/${
                this.props.rightImageID
              }/static`}
            />
          </Col>
        </Row>
        <Row>
          <Col style={{ textAlign: "center" }}>
            <Button
              variant="primary"
              size="sm"
              disabled={this.state.isProcessing}
              onClick={this.switchClicked}
            >
              <span className="fa fa-exchange" />
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  renderStep2() {
    return (
      <React.Fragment>
        <Row>
          <Image
            className="combine_image"
            src={"data:image/jpeg;base64," + this.state.croppedCombinedImage}
          />
        </Row>
      </React.Fragment>
    );
  }

  renderStep1() {
    return (
      <React.Fragment>
        <Row>
          <Image
            className="combine_image"
            src={"data:image/jpeg;base64," + this.state.combinedImage}
          />
        </Row>
      </React.Fragment>
    );
  }

  render() {
    const { step } = this.state;
    let stepFragment;

    if (step === 1) {
      stepFragment = this.renderStep1();
    } else if (step === 2) {
      stepFragment = this.renderStep2();
    } else {
      stepFragment = this.renderStep0();
    }

    return (
      <Modal
        backdrop="static"
        show={this.props.showCreateModal}
        onHide={this.handleCloseCreateModal}
        centered
        size="lg"
      >
        <Modal.Body>
          <Container>{stepFragment}</Container>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.handleCloseCreateModal}
          >
            {step > 0 ? "Back" : "Close"}
          </Button>
          <Button
            onClick={this.save}
            variant="info"
            disabled={this.state.isProcessing}
          >
            {step <= 0 ? "Combine" : "Save"}
          </Button>
          <div className="spinner_container">
            {" "}
            {this.state.isProcessing && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CombineImageModal;
